<div class="row" [formGroup]="form">
  <div class="col-12">
    <label class="bloco-titulo">Observações</label>
    <div class="editor-container">
      <ngx-editor-menu [editor]="editorObservacoes" [toolbar]="toolbar"></ngx-editor-menu>
      <ngx-editor [editor]="editorObservacoes" formControlName="observacoes"
        [placeholder]="ehOrcamento ? 'Condições, prazos e demais informações da proposta...' : 'Informações impressas no pedido...'">
      </ngx-editor>
    </div>
  </div>

  <div class="col-12 mt-3">
    <label class="bloco-titulo">
      Observações internas
      <span class="bloco-apoio">- não são impressas nem enviadas ao cliente</span>
    </label>
    <div class="editor-container">
      <ngx-editor-menu [editor]="editorInternas" [toolbar]="toolbar"></ngx-editor-menu>
      <ngx-editor [editor]="editorInternas" formControlName="observacoesInternas"
        placeholder="Recado para quem separa, fatura ou entrega...">
      </ngx-editor>
    </div>
  </div>

  <div class="col-12 col-md-6 mt-4">
    <app-select-pesquisavel
      label="Tags"
      [control]="tagsControl"
      [offlineList]="tags"
      idField="idTagVenda"
      nameField="descricao"
      corField="cor"
      [multiple]="true"
      [showBadges]="true"
      [disabled]="isSomenteLeitura"
      [hint]="tags.length ? '' : 'Nenhuma tag cadastrada para este documento.'"
      placeholder="Selecione...">
    </app-select-pesquisavel>
  </div>
</div>
